<!-- Sidepanel Bulk User Campaigns Update -->
<aside
  [ngClass]="{ active: userService.bulkCampaignUpdateModal.isModalOpen }"
  class="footer-sidepanel footer-sidepanel--customer-search footer-sidepanel--bulk-campaign"
>
  <!-- Header -->
  <div class="footer-sidepanel__header">
    <h5>
      <i class="fa-light fa-file-csv header-title-icon"></i>
      Bulk Update Agent Campaigns
    </h5>
    <a><i class="fa-light fa-xmark header-close-icon" (click)="closeModal()"></i></a>
  </div>

  <!-- Stepper Indicator -->
  <div class="bulk-stepper">
    <div class="bulk-stepper__step" [ngClass]="{ 'is-active': userService.bulkCampaignUpdateModal.step === 1, 'is-complete': userService.bulkCampaignUpdateModal.step > 1 }">
      <div class="bulk-stepper__circle">
        @if (userService.bulkCampaignUpdateModal.step > 1) {
          <i class="fa-light fa-check"></i>
        } @else {
          1
        }
      </div>
      <span class="bulk-stepper__label">Upload CSV</span>
    </div>
    <div class="bulk-stepper__line" [ngClass]="{ 'is-active': userService.bulkCampaignUpdateModal.step >= 2 }"></div>
    <div class="bulk-stepper__step" [ngClass]="{ 'is-active': userService.bulkCampaignUpdateModal.step === 2, 'is-complete': userService.bulkCampaignUpdateModal.step > 2 }">
      <div class="bulk-stepper__circle">
        @if (userService.bulkCampaignUpdateModal.step > 2) {
          <i class="fa-light fa-check"></i>
        } @else {
          2
        }
      </div>
      <span class="bulk-stepper__label">Review & Validate</span>
    </div>
    <div class="bulk-stepper__line" [ngClass]="{ 'is-active': userService.bulkCampaignUpdateModal.step === 3 }"></div>
    <div class="bulk-stepper__step" [ngClass]="{ 'is-active': userService.bulkCampaignUpdateModal.step === 3 }">
      <div class="bulk-stepper__circle">3</div>
      <span class="bulk-stepper__label">Summary</span>
    </div>
  </div>

  <!-- Content -->
  <div class="footer-sidepanel__content bulk-modal-body">
    <!-- Dedicated Loader on Sidepanel while Validating -->
    @if (userService.bulkCampaignUpdateModal.isValidating) {
      <div class="sidepanel-loader-wrapper">
        <div class="sidepanel-loader-spinner">
          <i class="fa-light fa-spinner-third fa-spin"></i>
        </div>
        <h5 class="sidepanel-loader-title">Validating File...</h5>
        <p class="sidepanel-loader-desc">Verifying Agent IDs and Campaign codes against the database.</p>
      </div>
    } @else {
      <!-- ==================== STEP 1: UPLOAD ==================== -->
      @if (userService.bulkCampaignUpdateModal.step === 1) {
        <div class="step-upload-container">
          <!-- Hidden File Input -->
          <input
            #fileInput
            type="file"
            accept=".csv"
            (change)="onFileSelected($event)"
            class="bulk-file-input--hidden"
          />

          <!-- When NO file is staged yet -->
          @if (!userService.bulkCampaignUpdateModal.file) {
            <!-- Sample File Bar -->
            <div class="sample-download-card">
              <div class="sample-download-card__icon">
                <i class="fa-light fa-file-excel"></i>
              </div>
              <div class="sample-download-card__content">
                <h6 class="sample-download-card__title">Sample CSV Template</h6>
                <p class="sample-download-card__desc">
                  Includes required columns <span class="no-wrap"><code>AgentID</code> and <code>Campaigns</code>.</span>
                </p>
              </div>
              <button (click)="downloadSample()" type="button" class="btn-sample-download">
                <i class="fa-light fa-download"></i>Download Sample
              </button>
            </div>

            <!-- Drag & Drop Zone -->
            <div
              class="bulk-dropzone"
              [ngClass]="{ 'is-dragging': isDragging }"
              (dragover)="onDragOver($event)"
              (dragleave)="onDragLeave($event)"
              (drop)="onFileDropped($event)"
              (click)="triggerFileInput()"
            >
              <div class="bulk-dropzone__icon-wrapper">
                <i class="fa-light fa-cloud-arrow-up"></i>
              </div>
              <h4 class="bulk-dropzone__heading">Drag & drop your CSV file here</h4>
              <p class="bulk-dropzone__subheading">or <span class="bulk-dropzone__browse-link">browse from your computer</span></p>
              <div class="bulk-dropzone__badge">
                <i class="fa-light fa-shield-check"></i> Only .csv files are supported
              </div>
            </div>

            <!-- CSV Specification Card -->
            <div class="csv-guide-card">
              <h6 class="csv-guide-card__title">
                <i class="fa-light fa-circle-info csv-guide-card__title-icon"></i> CSV File Format Guidelines
              </h6>
              <ul class="csv-guide-card__list">
                <li><strong>AgentID:</strong> The agent's identifier (e.g. <code>DM3</code>, <code>DM4</code>). Cannot be empty.</li>
                <li><strong>Campaigns:</strong> Comma-separated campaign codes (e.g. <code>P20,P21,P23</code> or <code>"P20,P21,P23"</code>).</li>
                <li><strong>First Campaign:</strong> Assigned as the agent's Primary campaign.</li>
                <li><strong>Replace Strategy:</strong> New campaigns will completely replace the agent's current campaign list.</li>
              </ul>
            </div>
          } @else {
            <!-- Staged File Card (Only staged file info shown, guidelines & sample removed) -->
            <div class="staged-file-card">
              <div class="staged-file-card__left">
                <div class="staged-file-card__icon">
                  <i class="fa-light fa-file-csv"></i>
                </div>
                <div class="staged-file-card__details">
                  <div class="staged-file-card__name">{{ userService.bulkCampaignUpdateModal.fileName }}</div>
                  <div class="staged-file-card__meta">
                    <span>{{ userService.bulkCampaignUpdateModal.fileSize }}</span>
                    <span class="staged-file-card__badge"><i class="fa-light fa-circle-check"></i> File loaded</span>
                  </div>
                </div>
              </div>
              <div class="staged-file-card__actions">
                <button
                  (click)="triggerFileInput()"
                  type="button"
                  class="btn-change-staged-file"
                  [disabled]="userService.bulkCampaignUpdateModal.isValidating"
                  title="Choose different file"
                >
                  <i class="fa-light fa-arrow-rotate-left"></i> Change
                </button>
                <button
                  (click)="removeStagedFile()"
                  type="button"
                  class="btn-remove-file"
                  [disabled]="userService.bulkCampaignUpdateModal.isValidating"
                  title="Remove file"
                >
                  <i class="fa-light fa-trash-can"></i> Remove
                </button>
              </div>
            </div>
          }
        </div>
      }

      <!-- ==================== STEP 2: REVIEW & VALIDATE ==================== -->
      @if (userService.bulkCampaignUpdateModal.step === 2) {
        <div class="step-review-container">
          <!-- Strict Blocking Alert Banner (Visible when errorCount > 0 and skipErrors is unchecked) -->
          @if (userService.bulkCampaignUpdateModal.errorCount > 0 && !userService.bulkCampaignUpdateModal.skipErrors) {
            <div class="strict-block-banner">
              <i class="fa-light fa-circle-exclamation strict-block-banner__icon"></i>
              <div class="strict-block-banner__text">
                <strong>Strict Validation Active:</strong>
                Found {{ userService.bulkCampaignUpdateModal.errorCount }} invalid row(s). You must fix all errors in your file or enable <strong>"Skip invalid rows"</strong> below to proceed with valid records only.
              </div>
            </div>
          }

          <!-- Toggle Controls & Export -->
          <div class="review-toolbar">
            <label class="skip-toggle-checkbox">
              <input
                type="checkbox"
                [checked]="userService.bulkCampaignUpdateModal.skipErrors"
                (change)="onSkipToggle($any($event.target).checked)"
              />
              <span class="skip-toggle-checkbox__label">
                Skip {{ userService.bulkCampaignUpdateModal.errorCount }} invalid row(s) and proceed with valid records
              </span>
            </label>

            @if (userService.bulkCampaignUpdateModal.errorCount > 0) {
              <button (click)="exportErrors()" type="button" class="btn-export-errors" title="Download CSV report of invalid rows">
                <i class="fa-light fa-file-arrow-down"></i>Export Error Report
              </button>
            }
          </div>

          <!-- Filter Tabs -->
          <div class="review-filter-tabs">
            <button
              (click)="setFilterTab('all')"
              [ngClass]="{ 'is-active': activeFilterTab === 'all' }"
              class="review-tab"
            >
              All ({{ userService.bulkCampaignUpdateModal.totalRows }})
            </button>
            <button
              (click)="setFilterTab('errors')"
              [ngClass]="{ 'is-active': activeFilterTab === 'errors' }"
              class="review-tab review-tab--errors"
            >
              <i class="fa-light fa-triangle-exclamation"></i>
              Errors ({{ userService.bulkCampaignUpdateModal.errorCount }})
            </button>
            <button
              (click)="setFilterTab('valid')"
              [ngClass]="{ 'is-active': activeFilterTab === 'valid' }"
              class="review-tab review-tab--valid"
            >
              <i class="fa-light fa-check"></i>
              Valid ({{ userService.bulkCampaignUpdateModal.validCount }})
            </button>
          </div>

          <!-- Review Grid -->
          <div class="review-table-wrapper">
            <table class="review-table">
              <thead>
                <tr>
                  <th class="th-col-row">Row</th>
                  <th class="th-col-agent">Agent ID</th>
                  <th class="th-col-name">Agent Name</th>
                  <th class="th-col-campaigns">Campaigns</th>
                  <th class="th-col-status">Status</th>
                  <th>Validation Message</th>
                </tr>
              </thead>
              <tbody>
                @for (row of getFilteredRows(); track row.rowNumber) {
                  <tr [ngClass]="{ 'row-has-error': row.status === 'error' }">
                    <td class="text-center">#{{ row.rowNumber }}</td>
                    <td><strong>{{ row.agentId || '—' }}</strong></td>
                    <td><span class="agent-name-cell">{{ row.userName || '—' }}</span></td>
                    <td>
                      <div class="campaign-chips-cell">
                        @for (c of row.campaigns; track c; let i = $index) {
                          <span
                            class="chips__value soft-border-4"
                            [ngClass]="i === 0 ? 'chips__value--success chips__value--green-outlined' : 'chips__value--tertiary'"
                          >
                            {{ c }}
                          </span>
                        }
                        @if (row.campaigns.length === 0) {
                          <span class="text-muted">—</span>
                        }
                      </div>
                    </td>
                    <td>
                      @if (row.status === 'valid') {
                        <span class="status-pill status-pill--valid">
                          <i class="fa-light fa-circle-check"></i> Valid
                        </span>
                      } @else {
                        <span class="status-pill status-pill--error">
                          <i class="fa-light fa-circle-xmark"></i> Error
                        </span>
                      }
                    </td>
                    <td>
                      @if (row.status === 'error') {
                        <span class="error-msg-text">
                          <i class="fa-light fa-triangle-exclamation"></i>
                          {{ row.message }}
                        </span>
                      } @else {
                        <span class="valid-msg-text">Ready to update</span>
                      }
                    </td>
                  </tr>
                }
                @if (getFilteredRows().length === 0) {
                  <tr>
                    <td colspan="6" class="table-empty-row">
                      No rows match the selected filter.
                    </td>
                  </tr>
                }
              </tbody>
            </table>
          </div>
        </div>
      }

      <!-- ==================== STEP 3: SUMMARY / SUCCESS ==================== -->
      @if (userService.bulkCampaignUpdateModal.step === 3) {
        <div class="step-summary-container">
          <div class="summary-success-icon">
            <i class="fa-light fa-circle-check"></i>
          </div>
          <h3 class="summary-title">Bulk Update Completed</h3>
          <p class="summary-subtitle">
            Agent campaign assignments have been updated successfully.
          </p>

          <!-- Result Metrics Cards -->
          <div class="summary-metrics-grid">
            <div class="summary-metric-card">
              <div class="summary-metric-card__value">{{ userService.bulkCampaignUpdateModal.totalRows }}</div>
              <div class="summary-metric-card__label">Total in File</div>
            </div>
            <div class="summary-metric-card summary-metric-card--success">
              <div class="summary-metric-card__value">{{ userService.bulkCampaignUpdateModal.summarySuccessCount }}</div>
              <div class="summary-metric-card__label">Updated Successfully</div>
            </div>
            <div class="summary-metric-card summary-metric-card--skipped">
              <div class="summary-metric-card__value">{{ userService.bulkCampaignUpdateModal.summarySkippedCount }}</div>
              <div class="summary-metric-card__label">Skipped (Errors)</div>
            </div>
          </div>

          @if (userService.bulkCampaignUpdateModal.summarySkippedCount > 0) {
            <div class="summary-error-download-card">
              <div>
                <strong>{{ userService.bulkCampaignUpdateModal.summarySkippedCount }} invalid row(s) were skipped.</strong>
                <p class="summary-error-download-card__desc">
                  Download the error report to review and fix the skipped records.
                </p>
              </div>
              <button (click)="exportErrors()" type="button" class="btn-sample-download">
                <i class="fa-light fa-file-arrow-down"></i>Download Error Log
              </button>
            </div>
          }
        </div>
      }
    }
  </div>

  <!-- Footer Actions -->
  <div class="footer-sidepanel__footer">
    <div class="bulk-footer-actions">
      @if (userService.bulkCampaignUpdateModal.step === 1) {
        <a (click)="closeModal()" class="single-button--without-bg btn-action-cancel">Cancel</a>
        @if (userService.bulkCampaignUpdateModal.file) {
          <button
            (click)="onValidate()"
            [disabled]="userService.bulkCampaignUpdateModal.isValidating"
            class="single-button--with-bg btn-action-validate"
          >
            @if (userService.bulkCampaignUpdateModal.isValidating) {
              <i class="fa-light fa-spinner-third fa-spin"></i>Validating...
            } @else {
              <i class="fa-light fa-circle-check"></i>Validate
            }
          </button>
        }
      }

      @if (userService.bulkCampaignUpdateModal.step === 2) {
        <a (click)="goToStep1()" class="single-button--without-bg btn-action-back">Back</a>
        <a (click)="closeModal()" class="single-button--without-bg btn-action-cancel">Cancel</a>

        <!-- Blocked Button when Strict validation fails -->
        @if (userService.bulkCampaignUpdateModal.errorCount > 0 && !userService.bulkCampaignUpdateModal.skipErrors) {
          <button class="single-button--with-bg btn-blocked" disabled title="Fix invalid rows or check 'Skip invalid rows' to proceed">
            <i class="fa-light fa-ban"></i>Fix Errors to Proceed
          </button>
        } @else {
          <button
            (click)="applyUpdates()"
            [disabled]="userService.bulkCampaignUpdateModal.isLoading || userService.bulkCampaignUpdateModal.validCount === 0"
            class="single-button--with-bg btn-action-apply"
          >
            @if (userService.bulkCampaignUpdateModal.isLoading) {
              <i class="fa-light fa-spinner-third fa-spin"></i>Updating...
            } @else {
              Apply Updates ({{ userService.bulkCampaignUpdateModal.validCount }})
            }
          </button>
        }
      }

      @if (userService.bulkCampaignUpdateModal.step === 3) {
        <a (click)="goToStep1()" class="single-button--without-bg btn-action-reset">
          <i class="fa-light fa-arrow-up-from-bracket"></i>Upload Another File
        </a>
        <button (click)="closeModal()" class="single-button--with-bg btn-action-done">
          Done
        </button>
      }
    </div>
  </div>
</aside>
